// Produce a cropped JPEG Blob from an image source + crop area (pixels).
export const getCroppedBlob = (imageSrc, cropPixels, outWidth = 1600) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = "anonymous";
    image.onload = () => {
      const aspect = cropPixels.width / cropPixels.height;
      const w = outWidth;
      const h = Math.round(outWidth / aspect);
      const canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(
        image,
        cropPixels.x, cropPixels.y, cropPixels.width, cropPixels.height,
        0, 0, w, h
      );
      canvas.toBlob(
        (blob) => (blob ? resolve(blob) : reject(new Error("Bijsnijden mislukt"))),
        "image/jpeg",
        0.9
      );
    };
    image.onerror = () => reject(new Error("Afbeelding laden mislukt"));
    image.src = imageSrc;
  });
